import { CircularProgress } from "@material-ui/core";
import { Text } from "components/Typography/text.styled";
import { BannerComponent } from "components/banners/banner.component";
import { LoggedOutPageContainer } from "components/pageLayouts/pageLayouts.styled";
import { Color } from "config/colors";
import { FontFamily, FontSize } from "config/font";
import { useTranslation } from "react-i18next";
import { TimeReports } from "web-apps/company/components/timeReportsV2/timeReports.component";
import { useCompanyStore } from "web-apps/company/stores/companyStore/companyStore";

export const TimeReportsV2Page = () => {
  const [companyState] = useCompanyStore();
  const [authState] = useCompanyStore();
  const { t } = useTranslation();
  return authState.isLoading || companyState.isLoading ? (
    <LoggedOutPageContainer>
      <CircularProgress />
    </LoggedOutPageContainer>
  ) : companyState.company?.verified ? (
    <TimeReports />
  ) : (
    <BannerComponent
      icon="clock"
      backgroundColor={Color.ChampagnePink}
      fill={Color.Destructive}
    >
      <Text
        fontSize={FontSize.Large}
        fontFamily={FontFamily.MontserratSemiBold}
        color={Color.Destructive}
      >
        {t("GigsCompany.UnverifiedAccount")}
      </Text>
      <Text>{t("GigsCompany.UnverifiedAccountDetails")}</Text>
    </BannerComponent>
  );
};
